import * as PayrollService from "@/shared/api/payrollService";
import * as storeHelper from "@/shared/storeHelper";
import {
    BankHolidayState,
    BankHolidaysInYear
} from "@/employer/types";
import moment from "moment";
import { FetchState } from "@/shared/types";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: BankHolidayState = {
    byYear: []
};

const emptyBankHolidaysInYear = (year: number): BankHolidaysInYear => ({
    year,
    holidays: [],
    fetchState: FetchState.Uninitialized
});
const getOrAddYearContainer = (state: BankHolidayState, year: number) => {
    let holidaysInYear = state.byYear.find(o => o.year === year);
    if (!holidaysInYear) {
        holidaysInYear = emptyBankHolidaysInYear(year);
        state.byYear.push(holidaysInYear);
    }

    return holidaysInYear;
};
export const useBankHolidayStore = defineStore("bankHoliday", {
    state: (): BankHolidayState => (_.cloneDeep(initialState)),
    getters: {
        bankHolidaysInYear: state => (year: number) => {
            const obj = state.byYear.find(o => o.year === year);
            return obj ? obj.holidays : [];
        },
        bankHolidaysInYearFetchState: state => (year: number) => {
            const obj = state.byYear.find(o => o.year === year);
            return obj ? obj.fetchState : FetchState.Uninitialized;
        },
        bankHolidaysInYearLoaded: state => (year: number) => {
            const obj = state.byYear.find(o => o.year === year);
            return obj ? obj.fetchState === FetchState.Loaded : false;
        },
    },
    actions: {
        setBankHolidays (value: { year: number, dates: string[] }) {
            const holidaysInYear = getOrAddYearContainer(this, value.year);
            holidaysInYear.holidays = value.dates;
            holidaysInYear.fetchState = FetchState.Loaded;
        },

        setYearOfBankHolidaysFetchState (value: { year: number, fetchState: FetchState }) {
            const holidaysInYear = getOrAddYearContainer(this, value.year);
            holidaysInYear.fetchState = value.fetchState;
        },
        loadBankHolidays (year: number) {

            if (this.bankHolidaysInYearFetchState(year) !== FetchState.Uninitialized) {
                return Promise.resolve();
            }

            this.setYearOfBankHolidaysFetchState({ year, fetchState: FetchState.Loading });

            return PayrollService.getBankHolidaysForYear(year).then(response => {
                const dates = response.data[year].map(holiday => moment(holiday.date).format("YYYY-MM-DD"));
                this.setBankHolidays({ year, dates });
            }).catch(err => {
                storeHelper.handleError({ error: err, rethrow: false });
            });
        }
    }
});